import type { AuthRepository } from '@core/repositories/AuthRepository';

export class ResendVerificationEmailUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(): Promise<void> {
    return this.authRepository.resendVerificationEmail();
  }
}
